export default __webpack_public_path__ + "static/media/meetings.6d1bde1d.svg";